import { MapToContext } from '@utils/objectWithDefault'

export class OriginCountry {
  constructor (originCountryData) {
    const defaultOriginCountry = {
      id: { val: -1, type: Number },
      name: { val: '', type: String },
      countryISO: { val: '', type: String }
    }

    MapToContext(this, defaultOriginCountry, originCountryData)
  }
  }
export class OriginCountries {
  constructor (originCountries) {
    const defaultOriginCountries = {
      options: { val: [], type: Array, subType: OriginCountry }
    }
    MapToContext(this, defaultOriginCountries, originCountries)
  }

  getEligibleOriginCountries () {
    return this.options
  }
  }
